// oxygen therapy
const single_flowmeter = require("../../assets/images/accessories/oxygen-therapy/single-flowmeter.png");
const twin_flowmeters = require("../../assets/images/accessories/oxygen-therapy/twin-flowmeters.png");
const piston_type_regulators = require("../../assets/images/accessories/oxygen-therapy/piston-type-regulators.png");
const diaphragm_type_regulators = require("../../assets/images/accessories/oxygen-therapy/diaphragm-type-regulators.png");
const econoline_flowmeters = require("../../assets/images/accessories/oxygen-therapy/econoline-flowmeters.png");
const humidifiers = require("../../assets/images/accessories/oxygen-therapy/humidifiers.png");
// suction
const vacuum_regulator_american = require("../../assets/images/accessories/suction/vacuum-regulator-american.png");
const vacuum_regulator_europeon = require("../../assets/images/accessories/suction/vacuum-regulator-europeon.png");

// central gas
const anesthesia_pendant = require("../../assets/images/accessories/central-gas/anesthesia-pendant.png");
const british_standard_terminal_units = require("../../assets/images/accessories/central-gas/british-standard-terminal-units.png");
const critical_area_bed_head_units = require("../../assets/images/accessories/central-gas/critical-area-bed-head-units.png");
const endoscopy_pendant = require("../../assets/images/accessories/central-gas/endoscopy-pendant.png");
const french_standard_terminal_units = require("../../assets/images/accessories/central-gas/french-standard-terminal-units.png");
const icu_pendand = require("../../assets/images/accessories/central-gas/ICU-Pendant.png");
const medical_column_colvari = require("../../assets/images/accessories/central-gas/Medical-Column-COLVARI.png");
const patient_bed_head_units = require("../../assets/images/accessories/central-gas/Patient-Bed-Head-Units.png");
const supply_beam = require("../../assets/images/accessories/central-gas/Supply-Beam-BYTREX.png");
const surgery_pendant_scentric = require("../../assets/images/accessories/central-gas/Surgery-Pendant-SCENTRIC.png");

// Probes & connectors
const chemtron_adaptors = require("../../assets/images/accessories/probs-connectors/Chemtron-Adaptors.png");
const din_standard_probes = require("../../assets/images/accessories/probs-connectors/DIN-Standard-Probes.png");
const chemtron_adaptor = require("../../assets/images/accessories/probs-connectors/Chemtron-adaptor.png");
const french_standard_probes = require("../../assets/images/accessories/probs-connectors/French-Standard-Probes.png");
const gas_scavenging_probes = require("../../assets/images/accessories/probs-connectors/Gas-Scavenging-Probes.png");
const japanese_standard_probes = require("../../assets/images/accessories/probs-connectors/Japanese-Standard-Probes.png");
const nist_fittings = require("../../assets/images/accessories/probs-connectors/NIST-Fittings.png");
const ohmeda_adaptors = require("../../assets/images/accessories/probs-connectors/Ohmeda-Adaptors.png");
const oxequip_adaptors = require("../../assets/images/accessories/probs-connectors/Oxequip-Adaptors.png");
const puritan_bennet_adaptors = require("../../assets/images/accessories/probs-connectors/Puritan-Bennett-Adaptors.png");
const quick_coupling = require("../../assets/images/accessories/probs-connectors/Quick-Coupling.png");
const british_standard_probes = require("../../assets/images/accessories/probs-connectors/British-Standard-Probes.png");

export const accessories_array = [
  {
    type: "All",
    instruments: [
      {
        image: chemtron_adaptors,
        title: "Chemtron Adaptors",
      },
      {
        image: din_standard_probes,
        title: "DIN Standard Probes",
      },
      {
        image: chemtron_adaptor,
        title: "DISS Fittings",
      },
      {
        image: french_standard_probes,
        title: "French Standard Probes",
      },
      {
        image: gas_scavenging_probes,
        title: "Gas Scavenging Probes",
      },
      {
        image: japanese_standard_probes,
        title: "Japanese Standard Probes",
      },
      {
        image: nist_fittings,
        title: "NIST Fittings",
      },
      {
        image: ohmeda_adaptors,
        title: "Ohmeda Adaptors",
      },
      {
        image: oxequip_adaptors,
        title: "Oxequip Adaptors",
      },
      {
        image: puritan_bennet_adaptors,
        title: "Puritan Bennett Adaptors",
      },
      {
        image: quick_coupling,
        title: "Quick Coupling",
      },
      {
        image: british_standard_probes,
        title: "British Standard Probes",
      },
      {
        image: single_flowmeter,
        title: "Single Flowmeter",
        working:
          "Flowmeters with an intrinsic ‘XenCon’ construction delivering precise control of the gas. Flowmeters without inlet connection and a threaded outlet connection to be used as a replacement or for client-specific requirements. ",
        description: [
          "The flowmeter is a finely crafted, back pressure compensated unit with an accuracy of ± 0.50 Liters per minute (LPM).The flowmeter body incorporates a stainless steel valve that allows precise adjustment of flow of gas. The flow tube and cover on the top of the unit are made from unbreakable polycarbonate material and provide a crystal clear view for easy adjustment of the flow rate. All the materials used combine to make this unit very long life and durable. The Herzmann Single Flowmeter for Oxygen and Air comes with a threaded outlet to attach a humidifier or a tubing nipple as per doctors’ discretion. It can be connected to a pressure regulator (reducer) to serve as a complete unit for delivering oxygen to the patients in a standalone device, where oxygen is not centrally available. The inlet is also threaded to enable usage in different applications. A medical gas adapter, according to any standard in the world can also be attached to the inlet, enabling the unit to be used in any hospital where oxygen / air are available through a centrally piped system.",
        ],
        characteristics: [
          "Stainless Steel body",
          "INLET: Standard Female 1/8” NPT",
          "OUTLET: Standard Male 9/16” Thread Outlet",
          "Possibility to attach a humidifier or a tubing nipple",
          "0 – 15 L/min standard flow rate",
          "Durable flow tube and outer cover",
          "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
        ],
      },
      {
        image: twin_flowmeters,
        title: "Twin Flowmeters",
        working:
          "Flowmeters with inlet connections/probes/adapters according to a wide range of International standards like British, German, French, Japanese, American types like Chemetron, Ohmeda, Oxequip, Puritan Bennett etc",
        description: [
          "The flowmeter is a finely crafted, back pressure compensated unit with an accuracy of ± 0.50 Litres per minute (LPM).",
          "The flowmeter body incorporates a stainless steel valve that allows precise adjustment of flow of gas.",
          "The flow tube and cover on the top of the unit are made from unbreakable polycarbonate material and provide a crystal clear view for easy adjustment of the flow rate.",
          "All the materials used combine to make this unit very long life and durable.",
          "These Flowmeters for Oxygen and Air comes with a threaded outlet to attach a humidifier or a tubing nipple as per doctors’ discretion.",
        ],
        characteristics: [
          "Stainless Steel body",
          "2 flowmeters combined to provide oxygen to two patients from one gas outlet",
          "INLET: Probes and adapters according to most international standards like British, German, Japanese, American etc",
          "OUTLET: Standard Male 9/16” Thread Outlet",
          "Possibility to attach a humidifier or a tubing nipple",
          "0 – 15 L/min standard flow rate",
          "Durable flow tube and outer cover",
          "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
        ],
      },
      {
        image: piston_type_regulators,
        title: "Piston Type Regulators",
        working:
          "Fixed Pressure Output regulators that offer a safe and very economical alternative to meet the gas supply requirements of the hospitals. Factory pre-set, fixed output pressure regulators with flow meters for attachment to cylinders only.",
        description: {
          describe: "They can be purchased with or without the humidifiers",
          heading: {
            heading1: "Regulator:",
            value1:
              "The pressure Regulator is used to reduce the high pressure from the Cylinder and feed the reduced pressure to the flowmeter. It has different type of inlet connections to connect to different type of cylinder connections available in the world. The pressure regulator is a factory-preset unit that delivers a fixed out put pressure. It is made of chrome plated brass and has an excess pressure relief valve. The gauge indicates the pressure in the cylinder, with clearly marked full and empty indications.",
            heading2: "Flowmeter:",
            value2:
              "The flowmeter is a finely crafted, back pressure compensated unit with an accuracy of ± 0.50 Litres per minute (LPM). The flow tube and cover on the top of the unit are made from unbreakable polycarbonate material and provide a crystal clear view for easy adjustment of the flow rate. The Flowmeter for Oxygen and Air comes with a threaded outlet to attach a humidifier or a tubing nipple as per doctors’ discretion.",
            heading3: "Humidifier:",
            value3:
              "The Herzmann Humidifier is designed to be attached to the oxygen and air flowmeters in order to add some moisture to the gas being supplied to the patients. The connecting nut is made of brass encased in ABS plastic thereby ensuring a comfortable and durable connection.  The cap is made from ABS material that is chosen because it is autoclavable, as well as to provide a strong and unbreakable nozzle. The bottle is made of polycarbonate and is autoclavable.",
          },
        },
        characteristics: {
          charac:
            "Fixed output pressure reducers available in a variety of configurations for use with Medical Oxygen, and Air",
          heading1: "Regulator",
          list1: [
            "Gauge Accuracy: +/-4% full scale.",
            "Gas Specific CGA and Bullnose Inlet connections",
            "Inlet: 3500-4000 psi",
            "Output: 50-60 psi",
            "With Safety Valve",
            "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
          ],
          heading2: "Flowmeter",
          list2: [
            "Back Pressure compensated",
            "Flow Rate: 15 I/min. Flush Flow up to 40 I/min",
            "Scale Graduated at 1 I/min. increments from 1 to 15ml",
            "Inlet Pressure 50 to 60 psi",
            "Unbreakable Flowtube and Outer Cover",
            "Possibility to attach a humidifier or a tubing nipple",
          ],
        },
      },
      {
        image: diaphragm_type_regulators,
        title: "Diaphragm Type Regulators",
        working:
          "A highly versatile, adjustable output pressure regulator, available in a wide range of inlet and outlet configurations.",
        description: [
          "A highly versatile, adjustable output pressure regulator, available in a wide range of inlet and outlet configurations.",
        ],
        characteristics: {
          charac:
            "Adjustable output pressure reducers available in a variety of configurations for use with Medical Oxygen, Nitrous Oxide and Air",
          heading1: "Features:",
          list1: [
            "Diaphragm type regulators with factory preset /adjustable output pressure",
            "A range of British Standard and CGA inlet connections like Bull Nose or Pin Index connections",
            "Possibility to order threaded outlets, attach flowmeters or attach quick connectors for hoses like Schraders",
            "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
            "Possibility to customize for special applications e.g., 2 gauges, on-site pressure adjustment, two outputs etc.",
          ],
        },
      },
      {
        image: econoline_flowmeters,
        title: "Econoline Flowmeters",
        working:
          "Econoline Flowmeters are available with a wide range of adaptations and inlet connections. These are made with the same care to quality asnd performance as all our products, but provide a solution for price conscious markets.",
        description: [
          "Econoline Flowmeters are available with a wide range of adaptations and inlet connections. These are made with the same care to quality asnd performance as all our products, but provide a solution for price conscious markets.",
        ],
        characteristics: [
          "Back Pressure Compensated",
          "Stainless Steel Valve",
          "Heavy Duty tube Cover and tube",
          "Brass Chromed Body",
          "ABS Adjusting Knob",
          "High contrast flow markings",
        ],
      },
      {
        image: vacuum_regulator_american,
        title: "Vacuum Regulator - American",
        working:
          "Stages Analogue Vacuum Regulator provides adjustable vacuum from zero to full-line vacuum. The vacuum regulator should be connected to a wall source of vacuum using a direct probe or through a rail mounting system.",
        description: [
          "This Vacuum Regulator can provide the maximum pressure immediately, unrestricted for emergencies.",
          "REG: Allows degree of vacuum to be adjusted by use of the regulating knob.",
          "OFF: Vacuum is no longer on or being supplied to patient.",
          "FULL: Maximum vacuum is administered to patient.",
        ],
        characteristics: {
          heading1: "American Style",
          list1: [
            "Ergonomic Mode Selector with high contrast markings",
            "Glow-in-Dark Gauge, with a color-coded flow range",
            "Large Pressure Adjusting Knob for easy adjustment of vacuum pressure",
            "Body made of durable, high-quality ABS for excellent protection",
            "Light-weighted",
            "Standard Safety Features include Bacterial Filter and Overflow Safety Trap",
          ],
        },
      },
      {
        image: vacuum_regulator_europeon,
        title: "Vacuum Regulator - European",
        working:
          "Three Stages Analogue Vacuum Regulator provides adjustable vacuum from zero to full-line vacuum.",
        description: [
          "The vacuum regulator should be connected to a wall source of vacuum using a direct probe or through a rail mounting system.",
          "This Vacuum Regulator can provide the maximum pressure immediately, unrestricted for emergencies.",
          "REG: Allows degree of vacuum to be adjusted by use of the regulating knob",
          "OFF: Vacuum is no longer on or being supplied to patient.",
          "FULL: Maximum vacuum is administered to patient.",
        ],
        characteristics: {
          heading1: "European Style",
          list1: [
            "Light-weighted, Fire retardant ABS plastic",
            "Ergonomic Mode Selector with high contrast markings",
            "Rotatable Gauge, with a color-coded flow range",
            "Large Pressure Adjusting Knob for easy adjustment of vacuum pressure",
            "Strong and Durable",
            "Standard Safety Features include Bacterial Filter and Overflow Safety Trap",
          ],
        },
      },
      {
        image: anesthesia_pendant,
        title: "Anesthesia Pendant - ARTEGO",
        working:
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        description: [
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        ],
        characteristics: [
          "Wide range for arms to rotate, high load capacity, smooth and reliable movement",
          "Full in-process and finished stage inspections",
          "Designed to keep the services separate to ensure patient safety",
          "Design allows for very convenient upgrades and extensions, at any time",
          "Easy to use controls that provide a comfortable operation",
          "Each rotary joint is fitted with pneumatic brake and friction brake, effectively preventing slips",
          "High strength aluminum",
          "Forward die extrusion die to form",
          "Powder coating on the surfaces",
          "Dustproof antifouling",
          "laminar-flow-optimized shape",
          "Streamlined structure",
          "4 times load-bearing test",
          "Full in-process and finished stage inspections",
        ],
      },
      {
        image: british_standard_terminal_units,
        title: "British Standard Terminal Units",
        working:
          "The terminal units are mechanical devices that form the end-point of the gas supply line in hospitals, clinics and vehicles. These units are medical gas supply points that provide a convenient and safe delivery of gas at the point where it is needed.",
        description: [
          "The terminal units are mechanical devices that form the end-point of the gas supply line in hospitals, clinics and vehicles. These units are medical gas supply points that provide a convenient and safe delivery of gas at the point where it is needed.",
          "Owing to the obvious danger of wrong connections where multiple gas outlets are installed at the same point, these units ensure fool-proof, mechanical, non-interchangeable gas connections.",
        ],
        characteristics: [
          "Designed to allow main body to be installed during construction, and final assembly after completion of all civil and MEP works.",
          "Marked and Indexed connection between main body and final assembly.",
          "Gas-specific full-color final assembly to help identify units.",
          "Available in a range of mounting arrangements –surface, flush, bedhead, pendant, ambulance etc.",
          "Possible to have NIST inlet connections also.",
          "100% inspection before delivery.",
        ],
      },
      {
        image: critical_area_bed_head_units,
        title: "Critical Area Bed Head Units",
        working:
          "Bed Head Units provide a common, integrated point-of-use platform for many services required by the patients including, but not limited to",
        description: {
          describe:
            "Bed Head Units provide a common, integrated point-of-use platform for many services required by the patients including, but not limited to:",
          list1: [
            "Medical Gases",
            "Communications",
            "Nurse call system",
            "Lighting",
            "Data and monitoring",
            "Audio Video Controls,",
          ],
        },
        characteristics: [
          "300+ mm height",
          "Two tiered unit to provide large number of gas and electric components w/o increasing length",
          "Ideal for Recovery Rooms and ICUs",
        ],
      },
      {
        image: endoscopy_pendant,
        title: "Endoscopy Pendant - ELITA",
        working:
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        description: [
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        ],
        characteristics: [
          "Wide range for arms to rotate, high load capacity, smooth and reliable movement",
          "Full in-process and finished stage inspections",
          "Designed to keep the services separate to ensure patient safety",
          "Design allows for very convenient upgrades and extensions, at any time",
          "Easy to use controls that provide a comfortable operation",
          "Each rotary joint is fitted with pneumatic brake and friction brake, effectively preventing slips",
          "High strength aluminum",
          "Forward die extrusion die to form",
          "Powder coating on the surfaces",
          "Dustproof antifouling",
          "laminar-flow-optimized shape",
          "Streamlined structure",
          "4 times load-bearing test",
          "Full in-process and finished stage inspections",
        ],
      },
      {
        image: french_standard_terminal_units,
        title: "French Standard Terminal Units",
        working:
          "The terminal units are mechanical devices that form the end-point of the gas supply line in hospitals, clinics and vehicles. These units are medical gas supply points that provide a convenient and safe delivery of gas at the point where it is needed.",
        description: [
          "The terminal units are mechanical devices that form the end-point of the gas supply line in hospitals, clinics and vehicles. These units are medical gas supply points that provide a convenient and safe delivery of gas at the point where it is needed.",
          "Owing to the obvious danger of wrong connections where multiple gas outlets are installed at the same point, these units ensure fool-proof, mechanical, non-interchangeable gas connections.",
        ],
        characteristics: [
          "Designed to allow main body to be installed during construction, and final assembly after completion of all civil and MEP works",
          "Marked and Indexed connection between main body and final assembly",
          "Chromed brass final assembly to provide long lasting service",
          "Available in a range of mounting arrangements –surface, flush, bedhead, pendant, ambulance etc",
          "Possible to have NIST inlet connections also 100% inspection before delivery",
          "Special boxes with lids for surface and flush mounting, with gas-specific color coded markings",
        ],
      },
      {
        image: icu_pendand,
        title: "ICU Pendant - ORBICU",
        working:
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        description: [
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        ],
        characteristics: [
          "Wide range for arms to rotate, high load capacity, smooth and reliable movement",
          "Full in-process and finished stage inspections",
          "Designed to keep the services separate to ensure patient safety",
          "Design allows for very convenient upgrades and extensions, at any time",
          "Easy to use controls that provide a comfortable operation",
          "Each rotary joint is fitted with pneumatic brake and friction brake, effectively preventing slips",
          "High strength aluminum",
          "Forward die extrusion die to form",
          "Powder coating on the surfaces",
          "Dustproof antifouling",
          "laminar-flow-optimized shape",
          "Streamlined structure",
          "4 times load-bearing test",
          "Full in-process and finished stage inspections",
        ],
      },
      {
        image: medical_column_colvari,
        title: "Medical Column - COLVARI",
        working:
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        description: [
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        ],
        characteristics: [
          "Wide range for arms to rotate, high load capacity, smooth and reliable movement",
          "Full in-process and finished stage inspections",
          "Designed to keep the services separate to ensure patient safety",
          "Design allows for very convenient upgrades and extensions, at any time",
          "Easy to use controls that provide a comfortable operation",
          "Each rotary joint is fitted with pneumatic brake and friction brake, effectively preventing slips",
          "High strength aluminum",
          "Forward die extrusion die to form",
          "Powder coating on the surfaces",
          "Dustproof antifouling",
          "laminar-flow-optimized shape",
          "Streamlined structure",
          "4 times load-bearing test",
          "Full in-process and finished stage inspections",
        ],
      },
      {
        image: patient_bed_head_units,
        title: "Patient Bed Head Units",
        working:
          "Bed Head Units provide a common, integrated point-of-use platform for many services required by the patients including, but not limited to",
        description: {
          describe:
            "Bed Head Units provide a common, integrated point-of-use platform for many services required by the patients including, but not limited to:",
          list1: [
            "Medical Gases",
            "Communications",
            "Nurse call system",
            "Lighting",
            "Data and monitoring",
            "Audio Video Controls",
          ],
        },
        characteristics: [
          "220 mm height",
          "Single tier unit incorporating gas and electric components, with room and reading lights",
          "Ideal for Wards and Patient Rooms",
        ],
      },
      {
        image: supply_beam,
        title: "Supply Beam - BYTREX",
        working:
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        description: [
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        ],
        characteristics: [
          "Wide range for arms to rotate, high load capacity, smooth and reliable movement",
          "Full in-process and finished stage inspections",
          "Designed to keep the services separate to ensure patient safety",
          "Design allows for very convenient upgrades and extensions, at any time",
          "Easy to use controls that provide a comfortable operation",
          "Each rotary joint is fitted with pneumatic brake and friction brake, effectively preventing slips",
          "High strength aluminum",
          "Forward die extrusion die to form",
          "Powder coating on the surfaces",
          "Dustproof antifouling",
          "laminar-flow-optimized shape",
          "Streamlined structure",
          "4 times load-bearing test",
          "Full in-process and finished stage inspections",
        ],
      },
      {
        image: surgery_pendant_scentric,
        title: "Surgery Pendant - SCENTRIC",
        working:
          "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
        description: {
          describe:
            "Multi Movement Pendants provide an efficient and flexible solution for gas delivery; electricity provision; equipment mounting; data, audio and video integration to all critical service areas like Operation Theaters and ICUs.",
          list1: [
            "Wide range for arms to rotate, high load capacity, smooth and reliable movement",
            "Full in-process and finished stage inspections",
            "Designed to keep the services separate to ensure patient safety",
            "Design allows for very convenient upgrades and extensions, at any time",
          ],
        },
        characteristics: [
          "Wide range for arms to rotate, high load capacity, smooth and reliable movement",
          "Full in-process and finished stage inspections",
          "Designed to keep the services separate to ensure patient safety",
          "Design allows for very convenient upgrades and extensions, at any time",
          "Easy to use controls that provide a comfortable operation",
          "Each rotary joint is fitted with pneumatic brake and friction brake, effectively preventing slips",
          "High strength aluminum",
          "Forward die extrusion die to form",
          "Powder coating on the surfaces",
          "Dustproof antifouling",
          "laminar-flow-optimized shape",
          "Streamlined structure",
          "4 times load-bearing test",
          "Full in-process and finished stage inspections",
        ],
      },
    ],
  },
  {
    type: "Probes & Connectors",
    instruments: [
      {
        image: din_standard_probes,
        title: "DIN Standard Probes",
      },
      {
        image: chemtron_adaptor,
        title: "DISS Fittings",
      },

      {
        image: gas_scavenging_probes,
        title: "Gas Scavenging Probes",
      },
      {
        image: japanese_standard_probes,
        title: "Japanese Standard Probes",
      },
      {
        image: nist_fittings,
        title: "NIST Fittings",
      },

      {
        image: british_standard_probes,
        title: "British Standard Probes",
      },
    ],
  },
  {
    type: "Oxygen Therapy",
    instruments: [
      {
        image: single_flowmeter,
        title: "Single Flowmeter",
        working:
          "Flowmeters with an intrinsic ‘XenCon’ construction delivering precise control of the gas. Flowmeters without inlet connection and a threaded outlet connection to be used as a replacement or for client-specific requirements. ",
        description: [
          "The flowmeter is a finely crafted, back pressure compensated unit with an accuracy of ± 0.50 Liters per minute (LPM).The flowmeter body incorporates a stainless steel valve that allows precise adjustment of flow of gas. The flow tube and cover on the top of the unit are made from unbreakable polycarbonate material and provide a crystal clear view for easy adjustment of the flow rate. All the materials used combine to make this unit very long life and durable. The Herzmann Single Flowmeter for Oxygen and Air comes with a threaded outlet to attach a humidifier or a tubing nipple as per doctors’ discretion. It can be connected to a pressure regulator (reducer) to serve as a complete unit for delivering oxygen to the patients in a standalone device, where oxygen is not centrally available. The inlet is also threaded to enable usage in different applications. A medical gas adapter, according to any standard in the world can also be attached to the inlet, enabling the unit to be used in any hospital where oxygen / air are available through a centrally piped system.",
        ],
        characteristics: [
          "Stainless Steel body",
          "INLET: Standard Female 1/8” NPT",
          "OUTLET: Standard Male 9/16” Thread Outlet",
          "Possibility to attach a humidifier or a tubing nipple",
          "0 – 15 L/min standard flow rate",
          "Durable flow tube and outer cover",
          "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
        ],
      },
      {
        image: twin_flowmeters,
        title: "Twin Flowmeters",
        working:
          "Flowmeters with inlet connections/probes/adapters according to a wide range of International standards like British, German, French, Japanese, American types like Chemetron, Ohmeda, Oxequip, Puritan Bennett etc",
        description: [
          "The flowmeter is a finely crafted, back pressure compensated unit with an accuracy of ± 0.50 Litres per minute (LPM).",
          "The flowmeter body incorporates a stainless steel valve that allows precise adjustment of flow of gas.",
          "The flow tube and cover on the top of the unit are made from unbreakable polycarbonate material and provide a crystal clear view for easy adjustment of the flow rate.",
          "All the materials used combine to make this unit very long life and durable.",
          "These Flowmeters for Oxygen and Air comes with a threaded outlet to attach a humidifier or a tubing nipple as per doctors’ discretion.",
        ],
        characteristics: [
          "Stainless Steel body",
          "2 flowmeters combined to provide oxygen to two patients from one gas outlet",
          "INLET: Probes and adapters according to most international standards like British, German, Japanese, American etc",
          "OUTLET: Standard Male 9/16” Thread Outlet",
          "Possibility to attach a humidifier or a tubing nipple",
          "0 – 15 L/min standard flow rate",
          "Durable flow tube and outer cover",
          "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
        ],
      },
      {
        image: piston_type_regulators,
        title: "Piston Type Regulators",
        working:
          "Fixed Pressure Output regulators that offer a safe and very economical alternative to meet the gas supply requirements of the hospitals. Factory pre-set, fixed output pressure regulators with flow meters for attachment to cylinders only.",
        description: {
          describe: "They can be purchased with or without the humidifiers",
          heading: {
            heading1: "Regulator:",
            value1:
              "The pressure Regulator is used to reduce the high pressure from the Cylinder and feed the reduced pressure to the flowmeter. It has different type of inlet connections to connect to different type of cylinder connections available in the world. The pressure regulator is a factory-preset unit that delivers a fixed out put pressure. It is made of chrome plated brass and has an excess pressure relief valve. The gauge indicates the pressure in the cylinder, with clearly marked full and empty indications.",
            heading2: "Flowmeter:",
            value2:
              "The flowmeter is a finely crafted, back pressure compensated unit with an accuracy of ± 0.50 Litres per minute (LPM). The flow tube and cover on the top of the unit are made from unbreakable polycarbonate material and provide a crystal clear view for easy adjustment of the flow rate. The Flowmeter for Oxygen and Air comes with a threaded outlet to attach a humidifier or a tubing nipple as per doctors’ discretion.",
            heading3: "Humidifier:",
            value3:
              "The Herzmann Humidifier is designed to be attached to the oxygen and air flowmeters in order to add some moisture to the gas being supplied to the patients. The connecting nut is made of brass encased in ABS plastic thereby ensuring a comfortable and durable connection.  The cap is made from ABS material that is chosen because it is autoclavable, as well as to provide a strong and unbreakable nozzle. The bottle is made of polycarbonate and is autoclavable.",
          },
        },
        characteristics: {
          charac:
            "Fixed output pressure reducers available in a variety of configurations for use with Medical Oxygen, and Air",
          heading1: "Regulator",
          list1: [
            "Gauge Accuracy: +/-4% full scale.",
            "Gas Specific CGA and Bullnose Inlet connections",
            "Inlet: 3500-4000 psi",
            "Output: 50-60 psi",
            "With Safety Valve",
            "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
          ],
          heading2: "Flowmeter",
          list2: [
            "Back Pressure compensated",
            "Flow Rate: 15 I/min. Flush Flow up to 40 I/min",
            "Scale Graduated at 1 I/min. increments from 1 to 15ml",
            "Inlet Pressure 50 to 60 psi",
            "Unbreakable Flowtube and Outer Cover",
            "Possibility to attach a humidifier or a tubing nipple",
          ],
        },
      },
      {
        image: diaphragm_type_regulators,
        title: "Diaphragm Type Regulators",
        working:
          "A highly versatile, adjustable output pressure regulator, available in a wide range of inlet and outlet configurations.",
        description: [
          "A highly versatile, adjustable output pressure regulator, available in a wide range of inlet and outlet configurations.",
        ],
        characteristics: {
          charac:
            "Adjustable output pressure reducers available in a variety of configurations for use with Medical Oxygen, Nitrous Oxide and Air",
          heading1: "Features:",
          list1: [
            "Diaphragm type regulators with factory preset /adjustable output pressure",
            "A range of British Standard and CGA inlet connections like Bull Nose or Pin Index connections",
            "Possibility to order threaded outlets, attach flowmeters or attach quick connectors for hoses like Schraders",
            "Filtered inlet to protect device from impurities in pipeline and to protect the patient",
            "Possibility to customize for special applications e.g., 2 gauges, on-site pressure adjustment, two outputs etc.",
          ],
        },
      },
      {
        image: econoline_flowmeters,
        title: "Econoline Flowmeters",
        working:
          "Econoline Flowmeters are available with a wide range of adaptations and inlet connections. These are made with the same care to quality asnd performance as all our products, but provide a solution for price conscious markets.",
        description: [
          "Econoline Flowmeters are available with a wide range of adaptations and inlet connections. These are made with the same care to quality asnd performance as all our products, but provide a solution for price conscious markets.",
        ],
        characteristics: [
          "Back Pressure Compensated",
          "Stainless Steel Valve",
          "Heavy Duty tube Cover and tube",
          "Brass Chromed Body",
          "ABS Adjusting Knob",
          "High contrast flow markings",
        ],
      },
      {
        image: humidifiers,
        title: "Humidifiers",
        working:
          "Microprocessor controlled respiratory humidifier for Adults and Pediatric use.",
        description: [
          "It has automatic humidity compensation. Separate temperature control, heated wire and non-heated wire mode, invasive and non-invasive mode, and over-heat protection function. ",
        ],
        characteristics: [],
      },
    ],
  },
  {
    type: "Suction",
    instruments: [
      {
        image: vacuum_regulator_europeon,
        title: "Vacuum Regulator - European",
        working:
          "Three Stages Analogue Vacuum Regulator provides adjustable vacuum from zero to full-line vacuum.",
        description: [
          "The vacuum regulator should be connected to a wall source of vacuum using a direct probe or through a rail mounting system.",
          "This Vacuum Regulator can provide the maximum pressure immediately, unrestricted for emergencies.",
          "REG: Allows degree of vacuum to be adjusted by use of the regulating knob",
          "OFF: Vacuum is no longer on or being supplied to patient.",
          "FULL: Maximum vacuum is administered to patient.",
        ],
        characteristics: {
          heading1: "European Style",
          list1: [
            "Light-weighted, Fire retardant ABS plastic",
            "Ergonomic Mode Selector with high contrast markings",
            "Rotatable Gauge, with a color-coded flow range",
            "Large Pressure Adjusting Knob for easy adjustment of vacuum pressure",
            "Strong and Durable",
            "Standard Safety Features include Bacterial Filter and Overflow Safety Trap",
          ],
        },
      },
    ],
  },
];
